import React, { Component } from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { PagesPaths } from '../../constants/Pages'
import { SubHero } from '../../components/header/SubHero'
import { pushGtmTrigger } from '../../utilities/window'
import { InquiryPathVersions } from '../../stores/inquiry'

class InquiryCreatedComponent extends Component {
  componentDidMount () {
    // get url query path-version
    const urlParams = new URLSearchParams(window.location.search)
    const pathVersion = urlParams.get('path-version') || InquiryPathVersions.V1
    if (pathVersion === InquiryPathVersions.V1.toString()) {
      pushGtmTrigger('generate_lead')
    } else {
      pushGtmTrigger('generate_lead_v2')
    }
  }

  render () {
    let { t, history } = this.props
    const breadcrumbs = [{ name: t('common:visits:my'), path: '' }]
    return (
      <div>
        <SubHero breadcrumb={breadcrumbs} />
        <div className='layout__container'>
          <img className='img--centered img--rounded' src='/app/images/checked_image.png' alt='validation' />
          <p className='paragraph--centered' style={{ marginTop: '20px' }}>
            {t('common:visits:confirmation_message_first')}
          </p>
          <p className='paragraph--centered'>
            {t('common:visits:confirmation_message_second')}
          </p>
          <p className='paragraph--centered'>
            {t('common:visits:confirmation_message_third_1')} <br />
            {t('common:visits:confirmation_message_third_2')}
          </p>
          <p className='paragraph--centered'>
            <a style={{ cursor: 'pointer' }}
              onClick={() => history.push(PagesPaths.INQUIRIES.path)}>{t('common:demande:link')}</a>
          </p>
        </div>
      </div>
    )
  }
}

InquiryCreatedComponent.propTypes = {
  t: func,
  history: object
}

export const InquiryCreatedPage = withRouter(translate()(InquiryCreatedComponent))



// WEBPACK FOOTER //
// ./src/pages/demande/InquiryCreatedPage.js